import { withApplicationUrl } from '../utils/with-application-url';

// When adding icons make sure you add PNG versions to /static/icons. We use them as product images in Shopify.

import candy from './candy.svg';
import chat from './chat.svg';
import checkmark from './checkmark.svg';
import diamond from './diamond.svg';
import gift from './gift.svg';
import multiple_gift from './multiple_gift.svg';
import giftwrap from './giftwrap.svg';
import hearth from './hearth.svg';
import key from './key.svg';
import lifebuoy from './lifebuoy.svg';
import message from './message.svg';
import plus from './plus.svg';
import shield from './shield.svg';
import star from './star.svg';
import thumbs_up from './thumbs_up.svg';
import truck from './truck.svg';
import fast_track1 from './fast_track1.svg';
import fast_track2 from './fast_track2.svg';
import mystery_gift from './mystery_gift.svg';
import vip from './vip.svg';

export const data = [
  {
    id: 'checkmark',
    name: 'Checkmark',
    icon: checkmark,
  },
  {
    id: 'candy',
    name: 'Candy',
    icon: candy,
  },
  {
    id: 'giftwrap',
    name: 'Gift Wrap',
    icon: giftwrap,
  },
  {
    id: 'gift',
    name: 'Gift',
    icon: gift,
  },
  {
    id: 'multiple_gift',
    name: 'Multiple Gift',
    icon: multiple_gift,
  },
  {
    id: 'lifebuoy',
    name: 'Lifebuoy',
    icon: lifebuoy,
  },
  {
    id: 'plus',
    name: 'Plus',
    icon: plus,
  },
  {
    id: 'star',
    name: 'star',
    icon: star,
  },
  {
    id: 'message',
    name: 'Message',
    icon: message,
  },
  {
    id: 'shield',
    name: 'Shield',
    icon: shield,
  },
  {
    id: 'diamond',
    name: 'Diamond',
    icon: diamond,
  },
  {
    id: 'chat',
    name: 'Chat',
    icon: chat,
  },
  {
    id: 'key',
    name: 'Key',
    icon: key,
  },
  {
    id: 'hearth',
    name: 'Hearth',
    icon: hearth,
  },
  {
    id: 'thumbs_up',
    name: 'Thumbs up',
    icon: thumbs_up,
  },
  {
    id: 'truck',
    name: 'Truck',
    icon: truck,
  },
  {
    id: 'fast_track1',
    name: 'Fast track 1',
    icon: fast_track1,
  },
  {
    id: 'fast_track2',
    name: 'Fast track 2',
    icon: fast_track2,
  },
  {
    id: 'mystery_gift',
    name: 'Mystery gift',
    icon: mystery_gift,
  },
  {
    id: 'vip',
    name: 'VIP',
    icon: vip,
  },
];

export default ({ name: icon }) => {
  const offerIcon = data.find((i) => i.id === icon);

  if (offerIcon) {
    return (
      <img src={withApplicationUrl(offerIcon.icon)} alt={offerIcon.name} />
    );
  } else {
    return <span>{icon} couldn't be found</span>;
  }
};
